<template>
	<li>
		<a href="#" class="uk-accordion-title">{{ displayNumber }}. Lights and Headboard</a>
		<div class="uk-accordion-content">
			<!-- Lights & Headboard -->
			<div class="lights-container">
				<template v-for="depth in depth_prices">
					<div v-if="depth.is_popular" :key="'depth_' + depth.id" class="uk-child-width-1-2@s uk-grid-collapse" uk-height-match=".light-description" uk-grid>
						<div @click.prevent="setDepth(depth, false)">
							<div class="light-type" :class="{'selected' : !depthSelected(depth)}">
								<p class="name">{{ depth.disabled_name }}</p>
								<div class="light-wrapper">
									<img :src="imagePath(depth.disabled_image)" :alt="depth.disabled_name + ' image'">
									<p class="light-description">
										{{ depth.disabled_description }}
									</p>
								</div>
							</div>
						</div>
						<div @click.prevent="setDepth(depth, true)">
							<div class="light-type" :class="{'selected' : depthSelected(depth)}">
								<p class="name">{{ depth.name }}
									<span v-if="useDiscounts && depth.discount_amount && false" class="extra-price old-price">{{ depth.price | diffcurrency }}</span>
									<span class="extra-price">{{ findActualDepthPrice(depth) | diffcurrency }}</span></p>
								<div class="light-wrapper">
									<img :src="imagePath(depth.image)" :alt="depth.name + ' image'">
									<p class="light-description">
										{{ depth.description }}
									</p>
								</div>
							</div>
						</div>
					</div>
				</template>
				<h4 class="split-title">Murphy Bed Depth</h4>
				<template v-for="option in additional_options">
					<div v-if="showOption(option)" :key="'addl_option_' + option.id" class="uk-child-width-1-2@s uk-grid-collapse" uk-height-match=".light-description" uk-grid>
						<div @click.prevent="setOption(option, false)">
							<div class="light-type" :class="{'selected' : !optionSelected(option)}">
								<p class="name">{{ option.disabled_name }} </p>
								<div class="light-wrapper">
									<img :src="imagePath(option.disabled_image)" :alt="option.disabled_name + ' image'">
									<p class="light-description">
										{{ option.disabled_description }}
									</p>
								</div>
							</div>
						</div>
						<div @click.prevent="setOption(option, true)">
							<div class="light-type" :class="{'selected' : optionSelected(option)}">
								<p class="name">{{ option.name }}
									<span class="extra-price">
										<span v-if="useDiscounts && option.discount_amount" class="extra-price old-price" style="display: inline-block;">
											{{ option.wallbed_upcharge | diffcurrency }}
										</span>
										{{ findActualItemPrice(option) | diffcurrency }}
									</span>
								</p>
								<div class="light-wrapper">
									<img :src="imagePath(option.image)" :alt="option.name + ' image'">
									<p class="light-description">
										{{ option.description }}
									</p>
								</div>
							</div>
						</div>
					</div>
				</template>
			</div>
		</div>
	</li>
</template>

<script>

import {mapState} from "vuex";

export default {
	name: "LightsHeadboard",

	props: {
    displayNumber:{
      type: Number,
      default: 2
    }
  },
	components: {},
	data() {
		return {}
	},
	mounted() {

	},
	methods: {
		depthSelected(depth) {
			return depth.id == this.selected_headboard.id;
		},
		setDepth(depth, setActive) {
			if (!setActive) { //this one is selected, set back to standard
				for (let i = 0; i < this.depth_prices.length; ++i) {
					if (Number(this.depth_prices[i].price) == 0) {
						this.$store.commit('setSelectedHeadboard', this.depth_prices[i]);
						break;
					}
				}
			} else {
				this.$store.commit('setSelectedHeadboard', depth);
			}
		},
		showOption(option) {
			if (option.is_popular) { //is popular
				for (let i = 0; i < option.depths.length; ++i) {
					if (option.depths[i].id == this.selected_headboard.depth_id) { //is available for current depth
						return true;
					}
				}
			}
			return false;
		},
		optionSelected(option) {
			for (let i = 0; i < this.selected_options.length; ++i) {
				if (this.selected_options[i].id == option.id) {
					return true;
				}
			}

			return false;
		},
		setOption(option, setActive) {
			let activeOptions = [];
			for (let i = 0; i < this.selected_options.length; ++i) {
				if (this.selected_options[i].id != option.id) { //re-store other options
					activeOptions.push(this.selected_options[i]);
				}
			}
			if (setActive) { // add if set to do so
				activeOptions.push(option);
			}
			this.$store.commit('setSelectedAdditionalOptions', activeOptions);
		},
		imagePath(image) {
			if (image) {
				return image.webPath + "/190/140";
			}

			return "/wp-content/themes/wallbeds/img/light-placeholder.jpg";
		},
		findActualDepthPrice(item){
			if(this.useDiscounts && item.discount_amount){
				return item.price - item.discount_amount;
			}
			return item.price;
		},
		findActualItemPrice(option){
			if(this.useDiscounts && option.discount_amount){
				return option.wallbed_upcharge - option.discount_amount;
			}
			return option.wallbed_upcharge;
		}
	},
	computed: {
		...mapState({
			selected_headboard: state => state.selected_headboard,
			selected_desk_table: state => state.selected_desk_table,
			depth_prices: state => state.depth_prices,
			desk_table_options: state => state.desk_table_options,
			additional_options: state => state.additional_options,
			selected_size: state => state.selected_size,
			selected_options: state => state.selected_options,
			useDiscounts: state => state.useDiscounts
		})
	},
	watch: {}
}
</script>